import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { MobileMenu } from './MobileMenu';

@Component
export class MobileMenuDrawerTrigger extends ThemeComponent {
    @Prop target!: string;
    hamburgerOpener = document.querySelector('[data-ref="hamburgerButton"]') as HTMLButtonElement;
    menu = document.querySelector('mobile-menu') as MobileMenu;

    init() {
        this.$listen(this, 'click', () => this.clicks());
    }
    clicks() {
        this.hamburgerOpener.click();
        const targetElem = this.menu.querySelector(`[data-handle="${this.target}"]`) as HTMLButtonElement;
        targetElem?.click();

    }
}
